import { useCallback } from 'react';
import { useFlagService } from '@atlassian/jira-flags';

type FlagProps = { title: string; description?: string };

export const useBoardCreateFlag = () => {
	const { showFlag } = useFlagService();

	const showSuccessFlag = useCallback(
		({ title, description }: FlagProps): void => {
			showFlag({
				type: 'success',
				title,
				description,
				isAutoDismiss: true,
				messageId: 'software-board-create.controllers.use-board-create-flag.show-flag.success',
				messageType: 'transactional',
			});
		},
		[showFlag],
	);

	const showErrorFlag = useCallback(
		({ title, description }: FlagProps): void => {
			showFlag({
				type: 'error',
				title,
				description,
				isAutoDismiss: true,
				messageId: 'software-board-create.controllers.use-board-create-flag.show-flag.error',
				messageType: 'transactional',
			});
		},
		[showFlag],
	);

	return { showSuccessFlag, showErrorFlag };
};
